import React from 'react';
import {WellniteArtImage} from '@website/types/art.types';

interface ImageWellniteArtProps {
  image: WellniteArtImage;
  className?: string;
}

export function ImageWellniteArt({
  image,
  className = '',
}: ImageWellniteArtProps): React.ReactElement {
  return (
    <img
      className={`lazy-load ${className}`}
      src={image.generatedImageThumbnailUrl}
      // data-src={generateWellniteArtSrcSet(image)}
      data-sizes="(max-width: 600px) 100vw, (max-width: 1080px) 50vw, 33vw"
      alt={image.generatedImageTitle ?? ''}
      sizes="(max-width: 600px) 100vw, (max-width: 1080px) 50vw, 33vw"
      loading="lazy"
      itemProp="image"
    />
  );
}
